const PRINT_STYLES = `
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { font-family: 'Courier New', monospace; color: #111; padding: 16px; font-size: 12px; }
    .doc { max-width: 720px; margin: 0 auto; }
    .head { display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #FF5A1F; padding-bottom: 10px; }
    .brand { font-size: 22px; font-weight: 800; letter-spacing: -0.5px; }
    .brand span { color: #FF5A1F; }
    h2 { font-size: 14px; text-transform: uppercase; letter-spacing: 2px; color: #555; }
    table { width: 100%; border-collapse: collapse; margin-top: 12px; }
    th, td { border: 1px solid #ddd; padding: 7px 9px; text-align: left; font-size: 12px; }
    th { background: #f6f6f6; }
    .row { display: flex; justify-content: space-between; gap: 20px; margin-top: 12px; }
    .box { flex: 1; border: 1px solid #ddd; padding: 10px; border-radius: 4px; }
    .box h3 { font-size: 11px; text-transform: uppercase; color: #777; margin-bottom: 4px; }
    .tot { margin-top: 12px; text-align: right; font-size: 13px; }
    .tot b { font-size: 16px; }
    .tri { height: 5px; background: linear-gradient(90deg,#FF9933 0 33%,#e5e5e5 33% 66%,#138808 66% 100%); border-radius: 3px; margin-top: 10px; }
    .terms { margin-top: 14px; border: 1px solid #ddd; border-radius: 4px; padding: 10px; font-size: 10px; color: #444; }
    .terms h3 { font-size: 11px; text-transform: uppercase; letter-spacing: 1px; color: #FF5A1F; margin-bottom: 5px; }
    .terms ol { padding-left: 16px; }
    .terms li { margin-bottom: 3px; line-height: 1.45; }
    .foot { margin-top: 18px; border-top: 1px dashed #aaa; padding-top: 8px; font-size: 10px; color: #666; text-align: center; }
    .mono { font-family: 'Courier New', monospace; font-weight: 700; }
    @media print { body { padding: 0; } }
  </style>`;

export function openPrintWindow(title, bodyHtml, page = "") {
  const w = window.open("", "_blank", "width=820,height=900");
  if (!w) return;
  const pageCss = "<style>@page { size: A4; margin: 12mm; }</style>";
  w.document.write(`<!DOCTYPE html><html><head><title>${title}</title>${PRINT_STYLES}${pageCss}</head>
    <body><div class="doc">${bodyHtml}</div></body></html>`);
  w.document.close();
  w.focus();
  setTimeout(() => w.print(), 350);
}

export function reportHtml(title, subtitle, columns, rows, totalRow) {
  const head = columns.map((c) => `<th>${c}</th>`).join("");
  const body = rows.map((r) => `<tr>${r.map((c) => `<td>${c}</td>`).join("")}</tr>`).join("");
  const tot = totalRow ? `<tr>${totalRow.map((c) => `<td><b>${c}</b></td>`).join("")}</tr>` : "";
  return `
    <div class="head"><div class="brand">INDIA<span>FAST</span><div style="font-size:10px;color:#138808;letter-spacing:2px">GLOBAL COURIERS</div></div>
      <div style="text-align:right"><h2>${title}</h2><p class="mono">${subtitle}</p></div></div>
    <div class="tri"></div>
    <table><tr>${head}</tr>${body}${tot}</table>
    <div class="foot">Generated ${new Date().toLocaleString("en-IN")} · INDIAFAST Global Couriers</div>`;
}

const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`;

export function invoiceHtml(inv, shipment) {
  return `
    <div class="head"><div class="brand"><span style="color:#FF5A1F">INDIA</span><span style="color:#1D4ED8">FAST</span><span style="font-size:10px;color:#138808;display:block;letter-spacing:2px">GLOBAL COURIERS</span></div>
      <div><h2>Tax Invoice</h2><p class="mono">${inv.invoice_number}</p></div></div>
    <div class="tri"></div>
    <div class="row">
      <div class="box"><h3>From (Billed By)</h3><p><b>${inv.billing?.name || ""}</b></p>
        <p>${inv.billing?.address || ""}, ${inv.billing?.city || ""} ${inv.billing?.pincode || ""}</p>
        <p>${inv.billing?.state || ""} · ${inv.billing?.phone || ""}</p></div>
      <div class="box"><h3>Ship To</h3><p><b>${inv.delivery?.name || ""}</b></p>
        <p>${inv.delivery?.address || ""}, ${inv.delivery?.city || ""} ${inv.delivery?.pincode || ""}</p>
        <p>${inv.delivery?.state || ""} · ${inv.delivery?.phone || ""}</p></div>
    </div>
    <div class="row">
      <div class="box"><h3>Shipment</h3><p>AWB: <span class="mono">${inv.awb}</span></p>
        <p>Order: <span class="mono">${inv.order_id}</span></p>
        <p>Courier: ${inv.courier_name || ""} · ${inv.service || ""}</p>
        <p>Date: ${new Date(inv.created_at).toLocaleString("en-IN")}</p></div>
    </div>
    <table><tr><th>Description</th><th>Qty</th><th>Taxable Value</th><th>GST 18%</th><th>Total</th></tr>
      <tr><td>${inv.items?.[0]?.description || "Courier service"}</td><td>${inv.items?.[0]?.qty || 1}</td>
        <td>${inr(inv.taxable_value)}</td><td>${inr(inv.gst_amount)}</td><td><b>${inr(inv.customer_price)}</b></td></tr>
    </table>
    <div class="tot"><p>Taxable: ${inr(inv.taxable_value)} · GST (18%): ${inr(inv.gst_amount)}</p>
      <p><b>Grand Total: ${inr(inv.customer_price)}</b></p></div>
    <div class="terms"><h3>Terms & Conditions</h3><ol>
      <li>All shipments are subject to INDIAFAST carriage terms; prohibited and restricted items are not accepted.</li>
      <li>Chargeable weight is the higher of actual vs volumetric weight (L×W×H ÷ 5000) as per courier network rules.</li>
      <li>Transit times shown are estimates; INDIAFAST is not liable for delays due to weather, customs or network disruptions.</li>
      <li>Claims for loss/damage must be raised within 7 days of delivery or expected delivery date, with invoice copy.</li>
      <li>Invoice is GST compliant (18% IGST/CGST-SGST as applicable); prices are inclusive of GST.</li>
      <li>COD amounts, if any, are settled to the registered wallet as per remittance cycle.</li>
      <li>Disputes are subject to Gurugram, Haryana jurisdiction only.</li>
    </ol></div>
    <div class="foot">INDIAFAST Global Couriers · GST compliant invoice · support@indiafast.in · This is a system-generated invoice.</div>`;
}

export function receiptHtml(shipment, markup) {
  const total = Number(shipment.customer_price || 0) + Number(markup || 0);  return `
    <div class="head"><div class="brand">INDIA<span>FAST</span></div>
      <div><h2>Customer Receipt</h2><p class="mono">${shipment.awb}</p></div></div>
    <div class="row">
      <div class="box"><h3>Received From</h3><p><b>${shipment.pickup?.name || ""}</b></p>
        <p>${shipment.pickup?.address || ""}, ${shipment.pickup?.city || ""} ${shipment.pickup?.pincode || ""}</p></div>
      <div class="box"><h3>Deliver To</h3><p><b>${shipment.delivery?.name || ""}</b></p>
        <p>${shipment.delivery?.address || ""}, ${shipment.delivery?.city || ""} ${shipment.delivery?.pincode || ""}</p></div>
    </div>
    <table><tr><th>AWB</th><th>Courier</th><th>Weight</th><th>Payment</th></tr>
      <tr><td class="mono">${shipment.awb}</td><td>${shipment.courier_name || ""}</td>
        <td>${shipment.chargeable_weight || shipment.weight || "-"} kg</td><td>${shipment.payment_type}</td></tr></table>
    <div class="tot">
      <p>Shipping Charges: ${inr(shipment.customer_price)}</p>
      ${markup > 0 ? `<p>Service / Handling Charges: ${inr(markup)}</p>` : ""}
      <p><b>Total Collected: ${inr(total)}</b></p></div>
    <div class="foot">Thank you for shipping with INDIAFAST · Track anytime at indiafast.in/track/${shipment.awb}<br/>
      Receipt generated by authorised INDIAFAST agent · ${new Date().toLocaleString("en-IN")}</div>`;
}

export function intlInvoiceHtml(inv, shipment) {
  const boxes = shipment?.boxes || inv?.boxes || [];
  const items = inv.items || [];
  const itemRows = items.map((it) => `<tr><td>${it.description}</td><td>${it.qty}</td><td>${inr(it.rate)}</td></tr>`).join("");
  return `
    <div class="head"><div class="brand"><span style="color:#FF5A1F">INDIA</span><span style="color:#1D4ED8">FAST</span><span style="font-size:10px;color:#138808;display:block;letter-spacing:2px">GLOBAL COURIERS · INTERNATIONAL</span></div>
      <div><h2>Tax Invoice (International)</h2><p class="mono">${inv.invoice_number}</p></div></div>
    <div class="tri"></div>
    <div class="row">
      <div class="box"><h3>From (Shipper)</h3><p><b>${inv.billing?.name || ""}</b></p>
        <p>${inv.billing?.address || ""}, ${inv.billing?.city || ""} ${inv.billing?.pincode || ""}, India</p>
        <p>${inv.billing?.phone || ""}</p></div>
      <div class="box"><h3>Ship To (Consignee)</h3><p><b>${inv.delivery?.name || ""}</b></p>
        <p>${inv.delivery?.address || ""}, ${inv.delivery?.city || ""} ${inv.delivery?.zipcode || ""}</p>
        <p><b style="color:#1D4ED8">${inv.delivery?.country || ""}</b> · ${inv.delivery?.phone || ""}</p></div>
    </div>
    <div class="row">
      <div class="box"><h3>Shipment</h3>
        <p>Order: <span class="mono">${inv.order_id}</span> · AWB: <span class="mono">${inv.awb}</span></p>
        <p>Service: <b>${inv.courier_name || ""} · ${inv.service || ""}</b></p>
        <p>Shipping Date: ${inv.shipping_date || "—"} · Payment: <b style="text-transform:uppercase">${inv.payment_mode || ""}</b></p>
        <p>Boxes: ${boxes.length || 1} · Billed Weight: <b>${inv.chargeable_weight || shipment?.chargeable_weight || "-"} kg</b> · Declared Value: ${inr(inv.total_value || 0)}</p></div>
    </div>
    <table><tr><th>Contents (per box)</th><th>Qty</th><th>Declared Value</th></tr>${itemRows}</table>
    <div class="tot"><p>Taxable: ${inr(inv.taxable_value)} · GST (18%): ${inr(inv.gst_amount)}</p>
      <p><b>Grand Total (received from customer): ${inr(inv.customer_price)}</b></p></div>
    <div class="terms"><h3>Terms & Conditions</h3><ol>
      <li>International carriage subject to INDIAFAST terms and destination country customs regulations.</li>
      <li>Chargeable weight per box = higher of actual vs volumetric (L×W×H ÷ 5000); multipiece billed as sum of boxes.</li>
      <li>Customs duties/taxes apply per selected service type (Duty Paid / receiver pays).</li>
      <li>Prohibited & restricted items as per IATA and destination country law are not accepted.</li>
      <li>Claims within 7 days of delivery with this invoice; medicine shipments require prescription & purchase bill.</li>
      <li>Tracking number is assigned after courier handover and shared on your dashboard.</li>
      <li>Disputes subject to Gurugram, Haryana jurisdiction only.</li>
    </ol></div>
    <div class="foot">INDIAFAST Global Couriers · International Division · support@indiafast.in · System-generated A4 invoice.</div>`;
}

export function boxLabelHtml(shipment, box, total) {
  const items = (box.items || []).map((it) => `${it.name} ×${it.quantity}`).join(", ") || "—";
  return `
    <div style="border:3px solid #0A1128;border-radius:14px;overflow:hidden;page-break-after:always;max-width:520px;margin:0 auto 24px">
      <div style="background:linear-gradient(90deg,#FF5A1F,#FF8A3D);color:#fff;padding:10px 16px;display:flex;justify-content:space-between;align-items:center">
        <b style="font-size:18px;letter-spacing:-0.5px">INDIA<span style="color:#0A1128">FAST</span></b>
        <span style="font-size:10px;letter-spacing:2px">INTERNATIONAL EXPRESS</span>
      </div>
      <div style="background:#0A1128;color:#fff;padding:12px 16px;display:flex;justify-content:space-between;align-items:center">
        <div><div style="font-size:9px;letter-spacing:2px;color:#8ea6e8">DESTINATION</div>
          <div style="font-size:30px;font-weight:800;color:#FF5A1F;line-height:1">${shipment.delivery?.country || ""}</div>
          <div style="font-size:12px;color:#cbd5e1">${shipment.delivery?.city || ""} ${shipment.delivery?.zipcode || ""}</div></div>
        <div style="text-align:right"><div style="font-size:9px;letter-spacing:2px;color:#8ea6e8">WEIGHT</div>
          <div style="font-size:30px;font-weight:800;color:#fff;line-height:1">${box.chargeable_weight || box.weight}<span style="font-size:14px">kg</span></div></div>
      </div>
      <div style="background:linear-gradient(135deg,#fff 0%,#FFF2EE 100%);padding:12px 16px">
        <div style="display:flex;justify-content:space-between;align-items:center;background:#FF5A1F;color:#fff;border-radius:8px;padding:8px 14px;box-shadow:0 4px 12px rgba(255,90,31,.35)">
          <span style="font-size:10px;letter-spacing:2px">BOX NUMBER</span>
          <span style="font-size:26px;font-weight:800">BOX ${box.box_no} / ${total}</span>
        </div>
        <table style="margin-top:10px"><tr><th>Field</th><th>Details</th></tr>
          <tr><td><b>Order / Invoice</b></td><td class="mono">${shipment.order_id} · ${shipment.invoice_number || ""}</td></tr>
          <tr><td><b>Consignee</b></td><td>${shipment.delivery?.name || ""} · ${shipment.delivery?.phone || ""}</td></tr>
          <tr><td><b>Address</b></td><td>${shipment.delivery?.address || ""}, ${shipment.delivery?.city || ""} ${shipment.delivery?.zipcode || ""}, ${shipment.delivery?.country || ""}</td></tr>
          <tr><td><b>Service</b></td><td>${shipment.service_name || shipment.courier_name || ""} · ${(shipment.service_type || "").toUpperCase()} · Ship: ${shipment.shipping_date || "—"}</td></tr>
          <tr><td><b>Contents</b></td><td>${items}</td></tr>
          <tr><td><b>Box Dims</b></td><td>${box.length || 0}×${box.width || 0}×${box.height || 0} cm · Actual ${box.weight || 0} kg</td></tr>
        </table>
        <p style="text-align:center;font-size:10px;color:#666;margin-top:8px;letter-spacing:3px">▲ THIS SIDE UP · HANDLE WITH CARE · INDIAFAST GLOBAL COURIERS ▲</p>
      </div>
    </div>`;
}

export function printAllBoxLabels(shipment) {
  const boxes = shipment.boxes || shipment.package?.boxes || [];
  if (!boxes.length) return;
  const html = boxes.map((b) => boxLabelHtml(shipment, b, boxes.length)).join("");
  openPrintWindow(`Box Labels ${shipment.order_id}`, html, "a4");
}
